<template lang="pug">
  .select-technician
    div
    //-BOTON REPARADO
    //- Da ingreso a bodega a un equipo reparado
    button.change-button(
        :disabled="disabled || loading"
        title="Ingresar a bodega reparado"
        data-testid="action-btn-ingresa-bodega-reparado"
        @click="crearMovimientoBodega(1, 3, 0, ot.tecnico_asignado.id, user.id, 'Bodega')")
        b-spinner(v-if="loading" small)
        span {{ loading ? 'Procesando...' : 'Ingresar a bodega reparado' }}
</template>

<script>
import { mapActions } from 'vuex'
import moment from 'moment'
import { ACTION_NAMES } from '@/utils/enums/actions'
import LoadingButtonMixin from '@/mixins/LoadingButtonMixin'

export default {
  name: 'ActionIngresarABodegaReparado',
  mixins: [LoadingButtonMixin],
  props: ['ot', 'disabled'],

  data() {
    return {
      user: null,
    }
  },
  created() {
    const { user } = JSON.parse(localStorage.getItem('user'))
    this.user = user
  },
  computed: {},
  methods: {
    ...mapActions('Warehouse', ['saveMovement']),
    ...mapActions('OTStore', ['editOT', 'getOT']),
    async crearMovimientoBodega(
      t_movimiento,
      t_entrada,
      t_salida,
      entregado,
      recibido,
      ubicacion_ot
    ) {
      try {
        await this.executeWithLoading(async () => {
          const data = {
            ot: this.ot.ot,
            tipo_movimiento: t_movimiento,
            tipo_entrada: t_entrada,
            tipo_salida: t_salida,
            entregado_por: entregado,
            recibido_por: recibido,
          }
          const resp = await this.saveMovement(data)
          console.log(data)
          if (resp.status === 200) {
            await this.editOT({
              ot: this.ot.ot,
              ubicacion: ubicacion_ot,
              action: ACTION_NAMES.ingresarABodegaReparado,
            })
            this.$bvToast.toast(
              `OT ingresada a las ${moment(resp.data.fecha_hora).format(
                'DD/MM/YYYY HH:mm'
              )}`,
              {
                variant: 'success',
              }
            )
            this.$emit('changed')
            await this.getOT(this.ot.ot)
          } else {
            this.$bvToast.toast(
              `Error al crear el movimiento de bodega: ${resp.data}`,
              {
                variant: 'danger',
              }
            )
          }
        })
      } catch (error) {
        console.error('Error al crear movimiento de bodega:', error)
        this.$bvToast.toast('Error al ingresar a bodega', {
          variant: 'danger',
        })
      }
    },
  },
}
</script>
